import React from 'react';

export const TitleHead = (props) => {
    return(
        <h1 className="TitleHead">{props.children}</h1>
    )
}